var Curriculog = Curriculog || {};

Curriculog.FlagFilter = (function ($, _, Backbone, FlagFilter) {

	FlagFilter = Backbone.View.extend({

		el: function () {
			return $('#report-9-flag');
		},

		events: {},

		initialize: function(options) {
			this.params = options.params;
			this.defaultQueries = options.defaultQueries;
		},

		get: function() {
			var flagFilter = this.params.queryParams.get('flag');
			if (flagFilter) {
				this.$el.attr('checked', true);
			} else {
				this.$el.attr('checked', false);
			}
			this.disable();
		},

		set: function() {
			var flag = (this.$el.is(':checked')) ? this.$el.val() : '';
			this.params.queryParams.set('flag', flag);
		},

		disable: function(event) {
			// disables checkbox if not available by default in the base query
			var allowedFlag = this.defaultQueries[this.params.domParams.get('tab')].allowedFlag();

			this.$el.attr('disabled', false);
			if (! allowedFlag) {
				this.$el.attr('disabled', true);
			}
		}

	});

	return FlagFilter;

})($, _, Backbone, Curriculog.FlagFilter || {});


